import { jsx as _jsx } from "react/jsx-runtime";
import { withSuperJSONPage as _withSuperJSONPage } from "babel-plugin-superjson-next/tools";
import { JobPostsSearchAndResults } from "@components/JobPosts/JobPostsSearchAndResults/JobPostsSearchAndResults";
import { Layout } from "@components/Layout/Layout";
function Home(param) {
    let { jobPosts , totalHits , nextCursor , jobPostSearchParams  } = param;
    return /*#__PURE__*/ _jsx(Layout, {
        pageTitle: "Find JavaScript Jobs",
        hasSearch: true,
        children: /*#__PURE__*/ _jsx("div", {
            className: "max-w-4xl m-auto",
            children: /*#__PURE__*/ _jsx(JobPostsSearchAndResults, {
                initialJobPostSearchParams: jobPostSearchParams,
                initialJobPosts: jobPosts,
                totalHits: totalHits,
                initialNextCursor: nextCursor
            })
        })
    });
}
export var __N_SSP = true;
export default _withSuperJSONPage(Home);
